export enum NotificationCode {
  AutoAssign = 'AUTO_MAINTAIN_ASSIGN',
  AgentReassign = 'AGENT_REASSIGN',
  AgentBlacklist = 'AGENT_BLACKLIST',
  ApplicationRequestCancel = 'APPLICATION_REQUEST_CANCEL',
  ApplicationRejected = 'APPLICATION_REJECTED',
  ApplicationCancelled = 'APPLICATION_CANCELLED',
  AssistedJourneySelected = 'ASSISTED_JOURNEY_SELECTED',

  // NOTE: we don't handle this code yet
  RecruitAssigned = 'RECRUIT_ASSIGNED',
  AssetPriceRequest = 'ASSET_PRICE_REQUEST',
  AgentSubmitLead = 'AGENT_SUBMIT_LEAD',
}

export const HANDLED_NOTIFICATION_CODES = [
  NotificationCode.AutoAssign,
  NotificationCode.AgentReassign,
  NotificationCode.AgentBlacklist,
  NotificationCode.ApplicationRequestCancel,
  NotificationCode.ApplicationRejected,
  NotificationCode.ApplicationCancelled,
  NotificationCode.AssistedJourneySelected,
];

export interface NotificationDetail {
  id: string;
  title: string;
  description: string;
  link: string | null;
  read: boolean;
  created_at: string;
}

export interface AutoAssignMetadata {
  total_agent: number;
  are_marketing_id: string;
}

export interface AgentReassignMetadata {
  agent_name: string;
  agents_count: number;
  new_are_name: string;
  old_are_name: string;
  product_type: string;
  agent_marketing_id: string;
  new_are_marketing_id: string;
  old_are_marketing_id: string;
}

export interface ApplicationRequestCancelMetadata {
  to?: {
    name: string;
    email: string;
  }[];
  subject?: string;
  variables?: {
    title: string;
    agent_id: string;
    applicant_name: string;
    application_id: string;
    recipient_name: string;
    application_group_id: string;
  };
  template_name?: string;
  agent_id?: string;
  application_group_id?: string;
  application_id?: string;
  cancellation_request_id?: string;
}

export interface ApplicationRejectedMetadata {
  agent_id: string;
  application_group_id: string;
  application_id: string;
  customer_name?: string;
  status?: string;
  tab?: string;
}

export interface ApplicationCancelledMetadata {
  agent_id: string;
  application_group_id: string;
  application_id: string;
  customer_name?: string;
  status?: string;
  cancellation_actor?: string;
  tab?: string;
}

export interface AssistedJourneySelectedMetadata {
  agent_id: string;
  application_group_id: string;
  application_id: string;
  customer_name?: string;
}

export type NotificationMetadata =
  | AutoAssignMetadata
  | AgentReassignMetadata
  | ApplicationRequestCancelMetadata
  | ApplicationRejectedMetadata
  | ApplicationCancelledMetadata
  | AssistedJourneySelectedMetadata;
export interface AutoAssignNotificationDetail extends NotificationDetail {
  metadata: AutoAssignMetadata;
}

export interface AgentReassignNotificationDetail extends NotificationDetail {
  metadata: AgentReassignMetadata;
}

export interface ApplicationRequestCancelNotificationDetail
  extends NotificationDetail {
  metadata: ApplicationRequestCancelMetadata;
}

export interface ApplicationRejectedNotificationDetail
  extends NotificationDetail {
  metadata: ApplicationRejectedMetadata;
}

export interface ApplicationCancelledNotificationDetail
  extends NotificationDetail {
  metadata: ApplicationCancelledMetadata;
}

export interface AssistedJourneySelectedNotificationDetail
  extends NotificationDetail {
  metadata: AssistedJourneySelectedMetadata;
}

export type Notification = {
  total: number;
  total_unread: number;
  code: NotificationCode;
  details: NotificationDetail[];
} & (
  | {
      code: NotificationCode.AutoAssign;
      details: AutoAssignNotificationDetail[];
    }
  | {
      code: NotificationCode.AgentReassign;
      details: AgentReassignNotificationDetail[];
    }
  | {
      code: NotificationCode.ApplicationRequestCancel;
      details: ApplicationRequestCancelNotificationDetail[];
    }
  | {
      code: NotificationCode.ApplicationRejected;
      details: ApplicationRejectedNotificationDetail[];
    }
  | {
      code: NotificationCode.ApplicationCancelled;
      details: ApplicationCancelledNotificationDetail[];
    }
  | {
      code: NotificationCode.AssistedJourneySelected;
      details: AssistedJourneySelectedNotificationDetail[];
    }
);

export interface GetResponseData {
  total: number;
  total_unread: number;
  notifications: Notification[];
}

export interface GetResponse {
  status: string;
  message: string;
  data: GetResponseData;
}

export interface PutResponse {
  data: string;
  status: string;
  message: string;
}

export interface DeleteResponse {
  data: {
    notification_ids: string[];
  };
  status: string;
  message: string;
}

// AGENT_REASSIGN
